import {
	createFileRoute,
	Outlet,
	useParams,
	useRouterState,
} from "@tanstack/react-router";
import { TicketAssetWorkspaceRecordsTable } from "@/features/tickets/components/ticket-asset-workspace-records-table";
import { isNestedRecordUnderAssetWorkspacePath } from "@/features/tickets/lib/is-nested-asset-workspace-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/assets/$assetId/workspace/records",
)({
	component: AssetWorkspaceRecordsTab,
	validateSearch: (search: Record<string, unknown>) => ({
		q: typeof search.q === "string" ? search.q : undefined,
	}),
});

/**
 * Asset workspace Records tab — table shell with outlet for record drawer / nested workspace.
 */
function AssetWorkspaceRecordsTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/assets/$assetId/workspace/records",
	});
	const pathname = useRouterState({
		select: (state) => state.location.pathname,
	});

	if (isNestedRecordUnderAssetWorkspacePath(pathname)) {
		return <Outlet />;
	}

	return (
		<div className="relative flex min-h-0 w-full flex-1 flex-col">
			<TicketAssetWorkspaceRecordsTable
				orgId={params.orgId}
				ticketId={params.ticketId}
				assetId={params.assetId}
			/>
			<Outlet />
		</div>
	);
}
